<template>
    <div :class="['animate-content-container', animation]" ref="contentRef">
        <div :class="['animate-content', animateStyleClass]" :style="{'transition-duration': animationDuration}">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default{
    props: {
        animateStyle: {
            type: String,
            default: 'fade-in', // Default typing speed if not provided from the parent
        },
        animationDuration: {
            type: String,
            default: 1
        }
    },
    data() {
        return {
            isVisible: false,
            observer: null,
            animation: ''
        };
    },
    computed: {
        animateStyleClass() {
            return this.isVisible ? this.animation : '';
        },
    },
    mounted() {
        this.initObserver();
        if(this.animateStyle == 'fade-in') {
            this.animation = 'animate-fade-in';
        } else if(this.animateStyle == 'fade-in-right') {
            this.animation = 'animate-fade-in-right';
        } else if(this.animateStyle == 'fade-in-left') {
            this.animation = 'animate-fade-in-left';
        } else if(this.animateStyle == 'fade-in-top') {
            this.animation = 'animate-fade-in-top';
        } else if(this.animateStyle == 'fade-in-bottom') {
            this.animation = 'animate-fade-in-bottom';
        } else if(this.animateStyle == 'move-in-bottom') {
            this.animation = 'animate-move-in-bottom';
        }
    },
    beforeDestroy() {
        if (this.observer) {
        this.observer.disconnect();
        }
    },
    methods: {
        initObserver() {
            this.observer = new IntersectionObserver(([entry]) => {
                this.isVisible = entry.isIntersecting && entry.intersectionRatio >= 0.5;
                if (this.isVisible) {
                    this.observer.disconnect();
                }
            }, {
                root: null,
                rootMargin: '0px',
                threshold: 0.5, // Fire the callback when 50% of the content is visible
            });
            if (this.$refs.contentRef) {
                this.observer.observe(this.$refs.contentRef);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
    .animate-content-container {
        position: relative;
        &.animate-fade-in-right .animate-content{
            transform: translateX(-100px);
        }
        &.animate-fade-in-left .animate-content{
            transform: translateX(100px);
        }
        &.animate-fade-in-top .animate-content{
            transform: translateY(100px);
        }
        &.animate-move-in-bottom .animate-content{
            transform: scaleY(0);
            transform-origin: top;
        }
        .animate-content{
            opacity: 0;
            &.animate-fade-in-left, &.animate-fade-in-right, &.animate-fade-in, &.animate-fade-in-top, &.animate-fade-in-bottom {
                opacity: 1;
                transform: translate(0);
                transition-property: opacity, transform;
            }
            &.animate-move-in-bottom{
                opacity: 1;
                transform: scale(1);
                transition-property: transform;
            }
        }
    }
</style>
